import { render, staticRenderFns } from "./LabelCategorySettingsActions.vue?vue&type=template&id=70a9ed9a&scoped=true&"
import script from "./LabelCategorySettingsActions.vue?vue&type=script&lang=js&"
export * from "./LabelCategorySettingsActions.vue?vue&type=script&lang=js&"
import style0 from "./LabelCategorySettingsActions.vue?vue&type=style&index=0&id=70a9ed9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9ed9a",
  null
  
)

export default component.exports